module.exports = __webpack_public_path__ + "img/zh_hk.a8551604.png";